'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import ClientExample from './ClientExample';
import Pricing from './Pricing';
import ReviewSummary from './ReviewSummary';
import Screenshot from './Screenshot';
import SocialScreenshots from './SocialScreenshots';
import SupportInfo from './SupportInfo';
import ThemeFeature from './ThemeFeature';
import ThemeProviderDetailsResponse from './ThemeProviderDetailsResponse';
const EMPTY_LIST = Immutable.List();
const ThemeOfferingRecord = Immutable.Record({
  homemade: false,
  installsCount: 0,
  firstPublishedAt: 0,
  slug: ''
});
const defaults = {
  benefits: '',
  businessTypes: EMPTY_LIST,
  casesUrl: null,
  changelog: null,
  chatUrl: null,
  clientExamples: EMPTY_LIST,
  exampleUrl: '',
  facebookUrl: null,
  features: EMPTY_LIST,
  forumUrl: null,
  name: '',
  offering: ThemeOfferingRecord(),
  offeringId: 0,
  pageFeatures: EMPTY_LIST,
  pageTypes: EMPTY_LIST,
  paypalEnabled: false,
  phone: null,
  pricing: new Pricing(),
  privacy2Url: null,
  privacy3Url: null,
  privacyUrl: '',
  profileUrl: null,
  provider: new ThemeProviderDetailsResponse(),
  reviewSummary: null,
  screenshots: EMPTY_LIST,
  setupUrl: '',
  socialScreenshots: new SocialScreenshots(),
  stripeEnabled: false,
  support: null,
  supportEmail: '',
  supportLanguages: EMPTY_LIST,
  supportUrl: null,
  tags: EMPTY_LIST,
  termsUrl: '',
  thumbnailUrl: '',
  tiers: EMPTY_LIST,
  verifiedAt: 0,
  versionNumber: 1,
  versionPublishedAt: 0,
  videoUrl: null,
  s3BucketKey: null
};

class ThemeDetailsResponse extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.businessTypes) {
      jsonCopy.businessTypes = Immutable.List(json.businessTypes);
    }

    if (json.clientExamples) {
      jsonCopy.clientExamples = Immutable.List(json.clientExamples.map(value => new ClientExample(value)));
    }

    if (json.features) {
      jsonCopy.features = Immutable.List(json.features.map(value => new ThemeFeature(value)));
    }

    if (json.offering) {
      jsonCopy.offering = ThemeOfferingRecord(json.offering);
    }

    if (json.pageFeatures) {
      jsonCopy.pageFeatures = Immutable.List(json.pageFeatures);
    }

    if (json.pageTypes) {
      jsonCopy.pageTypes = Immutable.List(json.pageTypes);
    }

    if (json.pricing) {
      jsonCopy.pricing = new Pricing(json.pricing);
    }

    if (json.provider) {
      jsonCopy.provider = new ThemeProviderDetailsResponse(json.provider);
    }

    if (json.reviewSummary) {
      jsonCopy.reviewSummary = new ReviewSummary(json.reviewSummary);
    }

    if (json.screenshots) {
      jsonCopy.screenshots = Immutable.List(json.screenshots.map(value => new Screenshot(value)));
    }

    if (json.socialScreenshots) {
      jsonCopy.socialScreenshots = new SocialScreenshots(json.socialScreenshots);
    }

    if (json.support) {
      jsonCopy.support = new SupportInfo(json.support);
    }

    if (json.supportLanguages) {
      jsonCopy.supportLanguages = Immutable.List(json.supportLanguages);
    }

    if (json.tags) {
      jsonCopy.tags = Immutable.List(json.tags);
    }

    if (json.tiers) {
      jsonCopy.tiers = Immutable.List(json.tiers);
    }

    super(cleanObject(jsonCopy));
  }

}

export default ThemeDetailsResponse;